import { render, staticRenderFns } from "./cardifao-list.vue?vue&type=template&id=a75b3dd2"
import script from "./cardifao-list.vue?vue&type=script&lang=ts"
export * from "./cardifao-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports